import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from "./Heading";
import Footer from "./Footer";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, LinearProgress, Stack, ThemeProvider, Typography, } from "@mui/material";
import getTheme from "./Theme";
import { getLayoutInfo } from "./LayoutInfo";
import { useEffect, useState } from "react";
import { ContentCardStacks } from "./components/ContentCardStacks";
import { restoreSession, useProfileAuthStore } from "./store/ProfileStore";
import { useNavigate } from "react-router-dom";
import { sendAjaxRequest } from "./API";
import { ContentCard } from "./components/ContentCard";
import { getChannelViewBaseURL, getContentURL } from "./ContentAPI";
import { queryFriends, setLastFriendImageUrl, useFriendsStore, } from "./store/FriendStore";
import { UserAvatar } from "./components/UserAvatar";
import { getChannelData } from "./store/ChannelStore";
import { FeedCardButton } from "./components/FeedCardButton";
import { listChannelsByOwner, } from "./util/DataUtils";
import { ChannelCard } from "./components/ChannelCard";
import { authUrl, useCacheBusterStore } from "./util/UrlUtils";
import { PersonAddAlt1, PersonRemoveAlt1 } from "@mui/icons-material";
import { useLogger } from "./logger";
const LOGPREFIX = "ProfileView: ";
const profileImg = "./img/profile_512.jpg";
let confirmAction;
export function ProfileView() {
    var _a;
    const cacheBusterStore = useCacheBusterStore((state) => state);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [forceRender, setForceRender] = useState(cacheBusterStore.getCacheBusterNumber());
    const [userId, setUserId] = useState();
    const [displayName, setDisplayName] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [sentUsFriendInvite, setSentUsFriendInvite] = useState(false);
    const [isFriend, setIsFriend] = useState(false);
    const [sentInvite, setSentInvite] = useState(true);
    const [evaluatedFriendsLists, setEvaluatedFriendsLists] = useState(false);
    const [completedMessage, setCompletedMessage] = useState(undefined);
    const [confirmPrompt, setConfirmPrompt] = useState(undefined);
    const [profileFriendsResponse, setProfileFriendsResponse] = useState();
    const [profileFriendsLoading, setProfileFriendsLoading] = useState(false);
    const [profileFriendsLoaded, setProfileFriendsLoaded] = useState(false);
    const [mutualFriends, setMutualFriends] = useState();
    const [feedData, setFeedData] = useState();
    const [channelsLoading, setChannelsLoading] = useState();
    const [channelsLoaded, setChannelsLoaded] = useState();
    const [channelsLoadError, setChannelsLoadError] = useState();
    const [channelIds, setChannelIds] = useState();
    const auth = useProfileAuthStore((state) => state);
    const friends = useFriendsStore((state) => state);
    const navigate = useNavigate();
    const logger = useLogger((state) => state);
    const layout = getLayoutInfo();
    const reset = () => {
        setUserId(undefined);
        setDisplayName(undefined);
        setProfileFriendsResponse(undefined);
        setMutualFriends(undefined);
        setDataLoaded(false);
        setProfileFriendsLoaded(false);
        setFeedData(undefined);
        setEvaluatedFriendsLists(false);
    };
    const userButtonClicked = (userId) => {
        logger.log(LOGPREFIX + "userButtonClicked: " + userId);
        navigate("/ProfileView?userId=" + userId);
        reset();
    };
    const loadData = () => {
        logger.log(LOGPREFIX + "Loading data...");
        if (!userId) {
            logger.error(LOGPREFIX + "userId not set");
            return;
        }
        setLoading(true);
        const apiCallback = (ok, status, message) => {
            setLoading(false);
            logger.log(LOGPREFIX + "searchCallback: " + message);
            try {
                if (ok) {
                    const result = JSON.parse(message);
                    if (result.bearer && result.sequence) {
                        auth.setBearerAndSequence(result.bearer, result.sequence, logger);
                    }
                    if (result.entries && result.entries.length == 1) {
                        setDisplayName(result.entries[0].displayName);
                        setDataLoaded(true);
                        loadUserChannels();
                    }
                    else {
                        setErrorMessage("Invalid User ID - No such user account was found. Please check the URL and try again.");
                    }
                }
                else {
                    const result = JSON.parse(message);
                    setErrorMessage(result.error + " (" + result.clientDetailCode + ")");
                }
            }
            catch (err) {
                logger.error(LOGPREFIX + "ERROR: " + err);
                setErrorMessage(err.message);
            }
        };
        const payload = {
            searchText: userId,
            sequence: auth.sequence,
            operation: "searchForUserById",
        };
        sendAjaxRequest(apiCallback, "search", payload, auth.bearer, cacheBusterStore, logger);
    };
    const loadUserChannels = () => {
        logger.log(LOGPREFIX + "loadUserChannels");
        if (!auth.userId || !userId) {
            logger.error(LOGPREFIX + "Missing user ID.");
            setChannelsLoading(false);
            setChannelsLoaded(true);
            return;
        }
        const input = {
            channelOwnerId: userId,
            operation: "listChannelsByOwner",
        };
        const callbacks = {
            okCallback: function (clientDetailCode, data) {
                setChannelsLoading(false);
                setChannelsLoaded(true);
                try {
                    const dataObj = JSON.parse(data);
                    if (dataObj === null || dataObj === void 0 ? void 0 : dataObj.channelIds) {
                        const newChannelIds = [];
                        dataObj === null || dataObj === void 0 ? void 0 : dataObj.channelIds.forEach((channelId) => {
                            if (!channelId.includes(userId + "/" + userId)) {
                                newChannelIds.push(channelId);
                            }
                        });
                        setChannelIds(newChannelIds);
                        logger.log(LOGPREFIX + "User Channel IDs: " + JSON.stringify(newChannelIds));
                    }
                }
                catch (err) {
                    logger.error(LOGPREFIX + err);
                    setChannelsLoadError(err.message);
                }
            },
            errorCallback: function (clientDetailCode, errorMessage) {
                const message = errorMessage
                    ? errorMessage + " (" + clientDetailCode + ")"
                    : "Unknown error (" + clientDetailCode + ")";
                setChannelsLoadError(message);
                setChannelsLoading(false);
                setChannelsLoaded(true);
            },
        };
        const authCallback = {
            isSignedIn: function () {
                return auth.isSignedIn();
            },
            bearer: function () {
                return auth.bearer;
            },
            sequence: function () {
                return auth.sequence;
            },
            setBearerAndSequence: function (bearer, sequence) {
                auth.setBearerAndSequence(bearer, sequence, logger);
            },
            getAuth: () => {
                return auth;
            },
        };
        listChannelsByOwner(input, callbacks, authCallback, cacheBusterStore, logger);
    };
    const sendInvite = (userId) => {
        logger.log(LOGPREFIX + "sendInvite: " + userId);
        setErrorMessage(undefined);
        setLoading(true);
        friends.sendInvite(userId, auth, cacheBusterStore, logger).finally(() => {
            setLoading(false);
            if (friends.error) {
                setErrorMessage(friends.error);
            }
            else {
                logger.log(LOGPREFIX + "Set Completed Message: Friend invited has been sent.");
                setCompletedMessage("Friend invited has been sent.");
                setSentInvite(true);
            }
        });
    };
    const acceptInvite = (userId) => {
        logger.log(LOGPREFIX + "acceptInvite: " + userId);
        setLoading(true);
        friends
            .acceptInvite(userId, auth, cacheBusterStore, logger)
            .then(() => {
            logger.log(LOGPREFIX + "acceptInvite: resolved");
            setIsFriend(true);
            setSentUsFriendInvite(false);
            logger.log(LOGPREFIX +
                "Set Completed Message: Friend invited has been accepted.");
            setCompletedMessage("Friend invited has been accepted.");
        })
            .catch((err) => {
            setErrorMessage(err.message);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const declineInvite = (userId) => {
        logger.log(LOGPREFIX + "declineInvite: " + userId);
        setLoading(true);
        friends
            .declineInvite(userId, auth, cacheBusterStore, logger)
            .then(() => {
            logger.log(LOGPREFIX + "declineInvite: resolved");
            setIsFriend(false);
            setSentUsFriendInvite(false);
            logger.log(LOGPREFIX +
                "Set Completed Message: Friend invited has been declined.");
            setCompletedMessage("Friend invited has been declined.");
        })
            .catch((err) => {
            setErrorMessage(err.message);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const confirmUnfriend = (userId) => {
        logger.log(LOGPREFIX + "confirmUnfriend: " + userId);
        setErrorMessage(undefined);
        setConfirmPrompt("Are you sure you want to remove your friend?");
        confirmAction = doUnfriend;
    };
    const doUnfriend = () => {
        logger.log(LOGPREFIX + "doUnfriend: " + userId);
        try {
            if (userId) {
                logger.log(LOGPREFIX + "doUnfriend: invoking store...");
                friends
                    .unfriend(userId, auth, cacheBusterStore, logger)
                    .then(() => {
                    logger.log(LOGPREFIX + "doUnfriend: OK");
                    if (!friends.error) {
                        setIsFriend(false);
                    }
                })
                    .catch((err) => {
                    logger.error(LOGPREFIX + "doUnfriend: catch " + err);
                    setErrorMessage(err.message);
                })
                    .finally(() => {
                    logger.log(LOGPREFIX + "doUnfriend: finally");
                    setLoading(false);
                    setErrorMessage(friends.error);
                });
            }
        }
        catch (err) {
            logger.error(LOGPREFIX + "doUnfriend: error = " + err);
            setErrorMessage(err.message);
            setLoading(false);
        }
    };
    useEffect(() => {
        const retVal = () => { };
        if (!auth || !auth.isSignedIn() || !userId || !dataLoaded) {
            logger.log(LOGPREFIX + "query - data not yet loaded");
            return retVal;
        }
        if (profileFriendsLoaded || profileFriendsLoading) {
            logger.log(LOGPREFIX + "query - already loading or loaded");
            return retVal;
        }
        setProfileFriendsLoading(true);
        queryFriends(userId, auth, cacheBusterStore, logger)
            .then((responseData) => {
            var _a;
            logger.log(LOGPREFIX + "query results = " + JSON.stringify(responseData));
            (_a = responseData === null || responseData === void 0 ? void 0 : responseData.entries) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                if (!a.displayName || !b.displayName) {
                    return 0;
                }
                return a.displayName.localeCompare(b.displayName);
            });
            setProfileFriendsResponse(responseData);
        })
            .finally(() => {
            setProfileFriendsLoading(false);
            setProfileFriendsLoaded(true);
        });
        getChannelData(userId, userId, auth, cacheBusterStore, logger)
            .then((feedData) => {
            logger.log(LOGPREFIX + "Setting Feed Data: " + JSON.stringify(feedData));
            setFeedData(feedData);
        })
            .catch((err) => {
            logger.error(LOGPREFIX + "Feed Data Load Failed: " + err);
        });
        return retVal;
    }, [auth, dataLoaded, profileFriendsLoaded]);
    useEffect(() => {
        var _a;
        const retVal = () => { };
        if (!profileFriendsLoaded || !profileFriendsResponse) {
            return retVal;
        }
        const myFriendsIds = [];
        const mutualFriends = [];
        if (friends.friends) {
            friends.friends.forEach((entry) => {
                if (entry.userId) {
                    myFriendsIds.push(entry.userId);
                }
            });
        }
        (_a = profileFriendsResponse.entries) === null || _a === void 0 ? void 0 : _a.forEach((entry) => {
            logger.log(LOGPREFIX + "Profile Friend Entry: " + JSON.stringify(entry));
            if (!entry.userId) {
                return;
            }
            if (myFriendsIds.includes(entry.userId)) {
                logger.log(LOGPREFIX + "Shared Friend: " + JSON.stringify(entry));
                mutualFriends.push(entry);
            }
        });
        mutualFriends.sort((a, b) => {
            if (!a.displayName || !b.displayName) {
                return 0;
            }
            return a.displayName.localeCompare(b.displayName);
        });
        setMutualFriends(mutualFriends);
        return retVal;
    }, [profileFriendsResponse, profileFriendsLoaded]);
    useEffect(() => {
        var _a, _b;
        if (!auth.isSignedIn(logger) || !auth.userId) {
            if (!restoreSession(auth, logger)) {
                logger.log(LOGPREFIX + "User NOT logged in - navigating...");
                navigate("/Welcome", { replace: true });
            }
        }
        else if (!dataLoaded) {
            const path = window.location.search
                ? window.location.search
                : window.location.href;
            const questionParts = path.split("?");
            if (questionParts.length != 2) {
                setErrorMessage("URL is invalid. Please check the URL and try again.");
                return;
            }
            const keyValues = questionParts[1].split("&");
            logger.log(LOGPREFIX + "keyValues = " + JSON.stringify(keyValues));
            keyValues.forEach((entry) => {
                const splitKeyValues = entry.split("=");
                if (splitKeyValues.length != 2) {
                    setErrorMessage("URL is invalid. Please check the URL and try again.");
                    return;
                }
                let key = splitKeyValues[0];
                if (key.startsWith("?")) {
                    key = key.substring(1, key.length);
                }
                const value = splitKeyValues[1].trim().toLocaleLowerCase();
                logger.log(LOGPREFIX + "key/value = " + key + " : " + value);
                if (key == "userId") {
                    logger.log(LOGPREFIX + "User ID = " + value);
                    setUserId(value);
                }
            });
        }
        else if (dataLoaded) {
            if (!friends.done &&
                !friends.loading &&
                !friends.error &&
                !friends.ok &&
                userId != auth.userId) {
                logger.log(LOGPREFIX + "Loading friend data...");
                friends
                    .load(auth.userId, auth, cacheBusterStore, logger)
                    .then(() => {
                    setEvaluatedFriendsLists(false);
                })
                    .catch((err) => {
                    logger.error(LOGPREFIX + err);
                    setErrorMessage(err.message);
                });
            }
            if (friends.ok &&
                friends.done &&
                !friends.error &&
                !friends.loading &&
                userId &&
                !evaluatedFriendsLists) {
                logger.log(LOGPREFIX + "Friend data loaded. Evaluating...");
                // Evaluate friend status
                setEvaluatedFriendsLists(true);
                (_a = friends.friends) === null || _a === void 0 ? void 0 : _a.forEach((entry) => {
                    if (entry.userId == userId) {
                        logger.log(LOGPREFIX + "USER IS FRIEND: " + userId);
                        setIsFriend(true);
                        setLastFriendImageUrl(getContentURL() + "/u/" + userId + "/profileImage_512.jpg");
                    }
                });
                (_b = friends.invites) === null || _b === void 0 ? void 0 : _b.forEach((entry) => {
                    if (entry.userId == userId) {
                        logger.log(LOGPREFIX + "USER SENT US FRIEND INVITE: " + userId);
                        setSentUsFriendInvite(true);
                    }
                });
                friends
                    .didSendInvite(userId, auth, cacheBusterStore, logger)
                    .then((checkResult) => {
                    setSentInvite(checkResult);
                })
                    .catch((err) => {
                    setErrorMessage(err.message);
                });
            }
        }
        return () => { };
    }, [auth, dataLoaded, friends]);
    useEffect(() => {
        logger.log(LOGPREFIX + "useEffect: userId = " + userId);
        if (userId && !dataLoaded && !errorMessage) {
            // Load Data
            loadData();
        }
        return () => { };
    }, [userId]);
    useEffect(() => {
        if (completedMessage) {
            setTimeout(() => {
                logger.log(LOGPREFIX + "Clearing completed message.");
                setCompletedMessage(undefined);
            }, 3500);
        }
        return () => { };
    }, [completedMessage]);
    useEffect(() => {
        if (auth.isSignedIn() && auth.userId && (friends === null || friends === void 0 ? void 0 : friends.userId) != auth.userId) {
            friends.load(auth.userId, auth, cacheBusterStore, logger);
            setEvaluatedFriendsLists(false);
        }
        return () => { };
    }, [friends, auth]);
    const cards = [];
    const buttonStyle = { paddingLeft: "15px", paddingRight: "15px" };
    const topButtons = displayName && (_jsx(Stack, Object.assign({ direction: "row", sx: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            margin: "3px",
            marginBottom: "0",
        } }, { children: _jsxs(ButtonGroup, Object.assign({ size: "small", variant: "outlined", "aria-label": "Basic button group" }, { children: [_jsx(Button, Object.assign({ variant: "outlined", sx: buttonStyle, onClick: () => {
                        navigate("/Profile");
                    } }, { children: "Profile" }), "profile-nav-button"), _jsxs(Button, Object.assign({ variant: "contained", sx: buttonStyle, onClick: () => { } }, { children: ["@", displayName] }), "display-name-button")] }), "top.buttons.buttongroup." + displayName) }), "top.buttons.stack." + displayName));
    if (dataLoaded && userId && displayName) {
        const actionsActive = sentUsFriendInvite ||
            (!isFriend &&
                !sentUsFriendInvite &&
                !sentInvite &&
                userId != auth.userId) ||
            (isFriend && userId != auth.userId) ||
            auth.userId == userId;
        const actions = (_jsxs(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [auth.userId == userId && (_jsx(Button, Object.assign({ variant: "contained", size: "medium", sx: { margin: "5px" }, color: "violet", onClick: () => {
                        navigate("/Profile");
                    } }, { children: "EDIT PROFILE SETTINGS" }), "edit-profile-button")), sentUsFriendInvite && (_jsx(Button, Object.assign({ variant: "contained", size: "medium", sx: { margin: "5px" }, color: "success", onClick: () => {
                        acceptInvite(userId);
                    } }, { children: "ACCEPT FRIEND INVITE" }), "accept-friend-invite-button")), sentUsFriendInvite && (_jsx(Button, Object.assign({ variant: "contained", size: "medium", sx: { margin: "5px" }, color: "error", onClick: () => {
                        declineInvite(userId);
                    } }, { children: "DECLINE FRIEND INVITE" }), "decline-friend-invite-button")), !isFriend &&
                    !sentUsFriendInvite &&
                    !sentInvite &&
                    userId != auth.userId && (_jsx(Button, Object.assign({ variant: "outlined", size: "medium", sx: { margin: "5px" }, color: "violet", onClick: () => {
                        sendInvite(userId);
                    }, endIcon: _jsx(PersonAddAlt1, {}) }, { children: "ADD FRIEND" }), "add-friend-button")), isFriend && userId != auth.userId && (_jsx(Button, Object.assign({ variant: "outlined", size: "medium", sx: { margin: "5px" }, color: "violet", onClick: () => {
                        confirmUnfriend(userId);
                    }, endIcon: _jsx(PersonRemoveAlt1, {}) }, { children: "REMOVE FRIEND" }), "remove-friend-button"))] })));
        const childComponent = (_jsxs(Stack, { children: [friends.loading && _jsx(LinearProgress, {}, "friends-loading-progress"), !friends.loading && isFriend && userId != auth.userId && (_jsx(Typography, Object.assign({ color: "#999999", variant: "body2", fontSize: "small", sx: { padding: 0, margin: 0, marginTop: "-10px" } }, { children: "(Friend)" }), "friend-status-text")), !friends.loading && userId == auth.userId && (_jsx(Typography, Object.assign({ color: "#999999", variant: "body2", fontSize: "small", sx: { padding: 0, margin: 0, marginTop: "-10px" } }, { children: "(Self)" }), "self-status-text")), completedMessage && (_jsx(Card, Object.assign({ elevation: 10, sx: {
                        backgroundColor: "#EEFFEE",
                        padding: layout.cardPadding,
                        margin: layout.cardMargin,
                        alignContent: "center",
                        textAlign: "center",
                    } }, { children: _jsxs(CardContent, Object.assign({ sx: {
                            padding: layout.cardContentPadding,
                            margin: layout.cardContentMargin,
                        } }, { children: [_jsx(Typography, Object.assign({ variant: "h6", color: "info" }, { children: "SUCCESS" }), "success-header-text"), _jsx(Typography, Object.assign({ variant: "body1", sx: {
                                    textAlign: "center",
                                    paddingLeft: layout.cardContentPadding,
                                    paddingRight: layout.cardContentPadding,
                                } }, { children: completedMessage }), "success-message-text")] }), "profileview.content.cardcontent.completed." + completedMessage) }), "profileview.content.card.completed")), errorMessage && (_jsx(Card, Object.assign({ elevation: 0, sx: {
                        backgroundColor: "#FFEEEE",
                        padding: "4",
                        marginTop: "0.5em",
                    }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", sx: { textAlign: "center" }, gutterBottom: true }, { children: "ERROR" }), "profile-error-header"), _jsx(Typography, Object.assign({ variant: "body2" }, { children: errorMessage }), "profile-error-message")] }, "profile-error-card-content") }), "profile-error-card"))] }, "completed.card.child.component.stack." + friends.loading));
        const userAvatar = (_jsx(UserAvatar, { userId: userId, keyStr: userId + ".avatar", onUserClicked: () => {
                userButtonClicked(userId);
            }, userName: displayName, userNameVisible: false, auth: auth }, userId + ".avatar"));
        cards.push(_jsx(ContentCard, { skipMediaLoadErrorLogs: true, keyStr: userId + ".user.content.card", title: displayName, titleAvatar: userAvatar, backgroundColor: "#FFFFFF", textColor: "#333333", maxWidth: 0.5, mediaUrl: authUrl(getContentURL() + "/u/" + userId + "/profileImage_512.jpg", cacheBusterStore, auth), mediaFallbackUrl: profileImg, actions: actionsActive ? actions : undefined, childComponent: childComponent }, userId + ".user.content.card"));
        if (mutualFriends || profileFriendsLoading) {
            const mutualFriendsElements = [];
            const friendsElements = [];
            if (auth.userId != userId) {
                mutualFriends === null || mutualFriends === void 0 ? void 0 : mutualFriends.forEach((entry) => {
                    if (!entry.userId || !entry.displayName) {
                        return;
                    }
                    const entryUserId = entry.userId;
                    mutualFriendsElements.push(_jsx(UserAvatar, { keyStr: entry.userId + ".avatar.mutualfriend", userId: entry.userId, userName: entry.displayName, onUserClicked: () => {
                            userButtonClicked(entryUserId);
                        }, userNameVisible: true, auth: auth }));
                });
            }
            (_a = profileFriendsResponse === null || profileFriendsResponse === void 0 ? void 0 : profileFriendsResponse.entries) === null || _a === void 0 ? void 0 : _a.forEach((entry) => {
                if (!entry.userId || !entry.displayName) {
                    return;
                }
                const entryUserId = entry.userId;
                friendsElements.push(_jsx(UserAvatar, { keyStr: entry.userId + ".avatar.friend", userId: entry.userId, userName: entry.displayName, onUserClicked: () => {
                        userButtonClicked(entryUserId);
                    }, userNameVisible: true, auth: auth }));
            });
            const friendsCardComponent = (_jsxs(Stack, Object.assign({ direction: "column" }, { children: [profileFriendsLoading && (_jsx(LinearProgress, { sx: { width: "100%" } }, "profile-friends-loading-progress")), mutualFriendsElements.length > 0 && (_jsx(Typography, Object.assign({ variant: "body1" }, { children: "Mutual Friends" }), "mutual-friends-title")), mutualFriendsElements && (_jsx(Stack, Object.assign({ direction: "row", alignItems: "center", sx: { display: "flex", justifyContent: "center" }, flexWrap: "wrap" }, { children: mutualFriendsElements }), "stack-row-mutualfriends")), mutualFriendsElements.length > 0 && (_jsx(Typography, Object.assign({ variant: "body1" }, { children: "Friends" }), "friends-title")), friendsElements && (_jsx(Stack, Object.assign({ direction: "row", alignItems: "center", sx: { display: "flex", justifyContent: "center" }, flexWrap: "wrap" }, { children: friendsElements }), "stack-row-friends"))] }), "friends-column-stack"));
            cards.push(_jsx(ContentCard, { keyStr: userId + ".profile.friends.card", title: "Friends", backgroundColor: "#FFFFFF", textColor: "#333333", maxWidth: 0.5, childComponent: friendsCardComponent }, userId + ".profile.friends.card"));
        }
        if (feedData) {
            cards.push(_jsx(FeedCardButton, { onClick: () => {
                    reset();
                    window.location.href = getChannelViewBaseURL() + displayName;
                }, feedTitle: feedData.title, feedDescription: feedData.description ? feedData.description : undefined, feedImageUrl: feedData.imageUrl
                    ? authUrl(feedData.imageUrl, cacheBusterStore, auth)
                    : undefined, displayName: displayName, userId: userId, auth: auth }, userId + ".feed.button"));
        }
    }
    if (channelsLoadError) {
        cards.push(_jsx(ContentCard, { keyStr: "content.card.error.mychannelsmessage", title: "ERROR", backgroundColor: "#FFEEEE", textColor: getTheme().palette.black.main, maxWidth: 0.5, childComponent: _jsx(Typography, Object.assign({ variant: "body1" }, { children: channelsLoadError }), "channels-load-error-text") }, "content.card.error.mychannelsmessage"));
    }
    else if (channelsLoaded) {
        channelIds === null || channelIds === void 0 ? void 0 : channelIds.forEach((channelId) => {
            // TODO: Replace with ChannelCard version of FeedButton (better UX)
            cards.push(_jsx(ChannelCard, { keyStr: "channelcard.mychannels." + channelId, enableEditButtons: false, basePath: getContentURL(), channelJson: channelId, maxWidth: 0.3 }, "channelcard.mychannels." + channelId));
        });
    }
    else if (channelsLoading) {
        cards.push(_jsx(LinearProgress, {}, "channels.loading.bar"));
    }
    logger.log(LOGPREFIX + "render: friends.loading = " + friends.loading);
    const confirmActionButtons = (_jsxs(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [_jsx(Button, Object.assign({ variant: "contained", color: "success", onClick: () => {
                    if (confirmAction) {
                        logger.log(LOGPREFIX + "Invoking confirmAction...");
                        confirmAction();
                    }
                    setConfirmPrompt(undefined);
                    confirmAction = undefined;
                } }, { children: "YES" }), "confirm-yes-button"), _jsx(Button, Object.assign({ variant: "contained", color: "error", onClick: () => {
                    setConfirmPrompt(undefined);
                    confirmAction = undefined;
                } }, { children: "NO" }), "confirm-no-button")] })));
    const confirmPromptObject = (_jsx(Stack, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: confirmPrompt }), "confirm-prompt-text") }), "confirm-prompt-stack"));
    const columnStack = (_jsx(ContentCardStacks, { keyStr: "cards.stack", cards: cards }, "cards.stack"));
    const content = (_jsxs(Stack, Object.assign({ sx: { padding: 0, margin: 0 }, spacing: 0 }, { children: [topButtons, loading && (_jsx(LinearProgress, { sx: { width: "100%", margin: "2px" } }, "progress")), errorMessage && (_jsx(Card, Object.assign({ elevation: 10, sx: {
                    backgroundColor: "#FFEEEE",
                    padding: layout.cardPadding,
                    margin: layout.cardMargin,
                    alignContent: "center",
                    textAlign: "center",
                } }, { children: _jsxs(CardContent, Object.assign({ sx: {
                        padding: layout.cardContentPadding,
                        margin: layout.cardContentMargin,
                    } }, { children: [_jsx(Typography, Object.assign({ variant: "h6", color: "error" }, { children: "ERROR" }), "error-header-text"), _jsx(Typography, Object.assign({ variant: "body1", sx: {
                                textAlign: "left",
                                paddingLeft: layout.cardContentPadding,
                                paddingRight: layout.cardContentPadding,
                            } }, { children: errorMessage }), "error-message-text")] }), "profileview.content.cardcontent.error") }), "profileview.content.card.error")), confirmPrompt && (_jsx(ContentCardStacks, { keyStr: "confirmation-card-stacks", cards: [
                    _jsx(ContentCard, { title: "CONFIRMATION", keyStr: "confirmation.card", backgroundColor: "#FFFFFF", textColor: "#333333", childComponent: confirmPromptObject, actions: confirmActionButtons, maxWidth: 0.5 }, "confirmation.card"),
                ] }, "confirmation-card-stacks")), !confirmPrompt && columnStack] }), "profileview.content.stack." + forceRender));
    const output = (_jsx("div", Object.assign({ style: { width: "100%", padding: 0, margin: 0 }, id: "outer" }, { children: _jsxs(ThemeProvider, Object.assign({ theme: getTheme() }, { children: [_jsx(Heading, {}), _jsx(Container, Object.assign({ sx: {
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        padding: 0,
                        margin: 0,
                    }, maxWidth: false }, { children: content })), _jsx(Footer, {})] })) }), "profileview.div" + forceRender));
    return output;
}
